import React from 'react';

interface BriefingDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  briefing: string;
  goalTitle: string;
}

export const BriefingDetailModal: React.FC<BriefingDetailModalProps> = ({
  isOpen,
  onClose,
  briefing,
  goalTitle
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Understanding Your Goal</h2>
              <p className="text-sm text-gray-600 mt-1">{goalTitle}</p>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <div className="prose prose-sm max-w-none">
            {briefing.includes('## ') ? (
              // Parse markdown headings (## Heading)
              briefing.split(/(## .+)/).map((section, index) => {
                if (section.startsWith('## ')) {
                  // This is a heading
                  const headingText = section.replace('## ', '').trim();
                  return (
                    <h3 key={index} className="text-lg font-semibold text-gray-900 mt-6 mb-3 first:mt-0">
                      {headingText}
                    </h3>
                  );
                } else if (section.trim()) {
                  // This is paragraph content
                  return (
                    <p key={index} className="text-gray-700 leading-relaxed mb-4">
                      {section.trim()}
                    </p>
                  );
                }
                return null;
              })
            ) : (
              // Fallback: plain text display
              <div className="whitespace-pre-line text-gray-700 leading-relaxed">
                {briefing}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

